import { createFileRoute, Outlet } from "@tanstack/react-router";
import { HoopoeLayout } from ":widgets/app-layout";
import { Suspense } from "react";
import { PageSkeleton } from ":shared/ui/skeleton";

export const Route = createFileRoute("/$locale/dashboard")({
	component: DashboardLayoutComponent,
});

function DashboardLayoutComponent() {
	return (
		<HoopoeLayout>
			<Suspense fallback={<PageSkeleton />}>
				<Outlet />
			</Suspense>
		</HoopoeLayout>
	);
}
